module.exports = __webpack_public_path__ + "img/baloonn.335b9c47.svg";